<template>
    <div>
        <v-app-bar
            color="blue-grey lighten-5"
            dark
            class="elevation-1"
        >

            <v-toolbar-title></v-toolbar-title>

            <v-spacer></v-spacer>


            <v-menu buttom offset-y transition="scale-transition" class="elevation-0"> 
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="#828282"
                        :ripple="false"
                        v-bind="attrs"
                        icon
                        v-on="on"
                        class="elevation-0 btnMenuTextNombre"
                        :class="usuario_nombre.length>15?'ml-2':''"
                        id="no-background-hover"
                    >
                        <img :src="usuario.foto_url" class="user-image" />
                        <label class="user-name">{{ usuario_nombre }}</label>
                        <v-icon class="">expand_more</v-icon>
                    </v-btn>
                </template>

                <div class="user-container">
                    <div
                        class="user-menu-item"
                        @click="cambiarPassword()"
                    >
                        <span>Cambiar contraseña</span>
                    </div>
                    <div
                        class="user-menu-item"
                        @click="cerrarSesion()"
                    >
                        <span>Salir</span>
                    </div>
                </div>
            </v-menu>
        </v-app-bar>

        <v-dialog v-model="modalCambiarPass" persistent :max-width="max_width">
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
            </template>
            <v-card>
                <v-card-title class="card_titulo card_texto pb-6">
                    <span class="modal-title" v-text="titulo_modal"></span>
                </v-card-title>
                <v-card-text :class="(accion == 'cambio_contraseña' || accion == 'cambio_password') ? 'card_texto pb-0' : 'card_texto pt-8 pb-0'">
                    <v-container grid-list-md class="pa-0" key="unique">

                        <template v-if="accion == 'cambio_contraseña'">
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pa-0">
                                <v-text-field
                                    outlined
                                    label="Contraseña actual"
                                    :type="show1 ? 'text' : 'password'"
                                    v-model="usuario.password"
                                    @keyup.enter="verificarPass('password_anterior')"
                                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="show1 = !show1"
                                />
                            </v-col>
                            <template v-if="aprovo_password">
                                <div class="d-flex">
                                    <v-icon class="icono-alert" style="padding-left: 0px; margin-top: 0px;"></v-icon>
                                    <div class="v-stepper__label" style="color: #FF5454; padding-left:5px; margin-top: 2px;">Contraseña incorrecta</div>
                                </div>
                            </template>
                        </template>

                        <template v-if="accion == 'cambio_password'">
                            <ValidationObserver ref="form2" v-slot="{ invalid }">
                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pa-0">
                                    <ValidationProvider v-slot="{ errors }" name="Nueva contraseña" rules="required|verify_password">
                                    <v-text-field
                                        id="nuevo_password"
                                        label="Nueva contraseña"
                                        outlined
                                        class="estiloLetras"
                                        v-model="nuevo_password"
                                        data-vv-name="contraseña"
                                        :error-messages="errors"
                                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="show2 = !show2"
                                        :type="show2 ? 'text' : 'password'"
                                    />
                                    </ValidationProvider>
                                </v-col>

                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-0 py-0">
                                    <ValidationProvider v-slot="{ errors }" name="Confirmar Contraseña" rules="required|verify_password">
                                    <v-text-field
                                        id="verificar_password"
                                        label="Confirmar contraseña"
                                        outlined
                                        class="estiloLetras"
                                        v-model="confirmacion"
                                        data-vv-name="confirmación"
                                        :error-messages="errors"
                                        @keyup.enter="verificarPass('confirmacion')"
                                        :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="show3 = !show3"
                                        :type="show3 ? 'text' : 'password'"
                                    />
                                    </ValidationProvider>
                                </v-col>
                                </ValidationObserver>
                            <template v-if="password_igual">
                                <div class="d-flex">
                                    <v-icon class="icono-alert" style="padding-left: 0px; margin-top: 0px;"></v-icon>
                                    <div class="v-stepper__label" style="color: #FF5454; padding-left:5px; margin-top: 2px;">Las contraseñas no son iguales, favor de verificar.</div>
                                </div>
                            </template>
                        </template>
                    </v-container>
                </v-card-text>
                <v-card-actions class="d-flex justify-end card_accion">
                    <button class="btnCerrar" @click="cerrarModal()">Cerrar</button>
                    <v-btn color="btnGuardar" v-if="accion == 'cambio_contraseña'" @click="verificarPass('password_anterior')">Verificar</v-btn>
                    <v-btn color="btnGuardar" v-if="accion == 'cambio_password'" @click="verificarPass('confirmacion')">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_primer_login"
            persistent
            max-width="420px"
        >
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
            </template>
            <v-card>
                <ValidationObserver ref="form" v-slot="{ invalid }">
                    <v-card-title class="padding-x50 pt-9 pb-8">
                        <span class="titleModal" v-text="titulo_modal"></span>
                    </v-card-title>
                    <v-card-text class="card_texto">
                        <v-container grid-list-md key="unique"> 
                            <v-row class="align-center justify-center"><span id="span_cambio">Por políticas, es requerido cambiar la contraseña.</span></v-row>
                            <v-row class="pt-4">
                                <v-col cols="12" xs="12" sm="12" md="12" class="my-0 pa-0">
                                    <ValidationProvider v-slot="{ errors }" name="Contraseña" rules="required|verify_password">
                                        <v-text-field
                                            outlined
                                            label="Nueva contraseña"
                                            v-model="nuevo_password"
                                            id="nuevo_password"
                                            class="py-0"
                                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show1 = !show1"
                                            :type="show1 ? 'text' : 'password'"
                                            auto
                                            :error-messages="errors" 
                                            required
                                        />
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" xs="12" sm="12" md="12" class="my-0 pa-0">
                                    <ValidationProvider v-slot="{ errors }" name="Confirmación" rules="required|verify_password">
                                        <v-text-field
                                            outlined
                                            label="Confirmar la contraseña"
                                            v-model="confirmacion"
                                            id="verificar_password"
                                            class="py-0"
                                            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show2 = !show2"
                                            :type="show2 ? 'text' : 'password'"
                                            auto
                                            @keyup.enter="verificar('confirmacion')"
                                            :error-messages="errors" 
                                            required
                                        />
                                    </ValidationProvider>
                                </v-col>
                                <div
                                    v-if="password_igual"
                                    class="v-stepper__label"
                                    style="color:#FF5454; padding-left: 3%; margin-top: -5%;"
                                >
                                    Las contraseñas no son iguales, favor de verificar.
                                </div>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end card_accion pt-0">
                        <v-btn color="btnGuardar" @click="verificar()">Guardar</v-btn>
                    </v-card-actions>
                </ValidationObserver>
            </v-card>
        </v-dialog>




    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Notify from "@/plugins/notify";
import userApi from "../api/usuarios";
import GetUrlImg from "@/plugins/Urlimagen";


export default {
    data() {
        return {
            datosLogin : null,
            modalCambiarPass: false,
            max_width: '420px',
            accion: "cambio_contraseña",
            titulo_modal: "¿Cambiar contraseña?",
            usuario_nombre: '',
            usuario: {
                id: 0,
                nombre: "",
                apellido_paterno: "",
                apellido_materno: "",
                puesto: "",
                email: "",
                usuario: "",
                fecha_nacimiento: "",
                telefono: "",
                celular: "",
                password: "",
                primer_inicio_sesion: "",
                rol_id: "",
                foto_url: ""
            },
            nuevo_password: "",
            confirmacion: "",
            aprovo_password: false,
            password_igual: false,

            dialog_primer_login: false,
            show1: false,
            show2: false,
            show3: false,
            user_vuex	: {
				email	: "",
				password: "",
			},
            loading01: false,
            loading02: false,

        }
    },
    computed: {
        ...mapState("auth", ["datos", "user", "foto_usr", "error", "menu", "logotipo"]),
    },
    methods: {
        ...mapActions("auth", ["logout", "update_password", "update_cliente"]),

        cambiarPassword() {
            this.modalCambiarPass   = true;
            this.max_width      = "420px";
            this.accion         = "cambio_contraseña";
            this.titulo_modal   = "¿Cambiar contraseña?";
        },
        async cerrarSesion(){
            await this.logout();
            this.$router.push("/");
        },
        
        verificar() {
			this.$refs.form.validate().then(success => {
				if(!success) {
                    return;
                }
				if (success) {
					if (this.confirmacion == this.nuevo_password) {
						this.password_igual = false;
						this.update();
					} 
					else {
						this.password_igual = true;
					}
				}
			});
		},
        async update() {
			this.llena_datos();
            this.loading01 = true
			await this.update_password(this.user_vuex);
			await userApi.updatePassword(this.usuario).then((response) => {
                userApi.getUsuario(this.usuario.id).then((response) => {
                    this.update_cliente(response)
                })
                .catch((err) => {
                    console.log(err)
                });
                this.cerrarModal();
                this.loading01 = false
                Notify.Success("Operación exitosa", "cliker® ya esta listo.");
            })
			.catch((err) => {
                this.loading01 = false
                Notify.Alert("Error", err.response.data.error);
            });
		},
        llena_datos() {
			this.usuario.id 				= this.datos.id;
			this.usuario.nombre 			= this.datos.nombre;
			this.usuario.apellido_paterno 	= this.datos.apellido_paterno;
			this.usuario.apellido_materno 	= this.datos.apellido_materno;
			this.usuario.puesto 			= this.datos.puesto;
			this.usuario.email 				= this.datos.email;
			this.usuario.telefono 			= this.datos.telefono;
			this.usuario.celular 			= this.datos.celular;
			this.rol_nombre 				= this.datos.rol.display_name;
			this.usuario.rol_id				= this.datos.rol.id;
			this.usuario.primer_inicio_sesion = false;
			this.usuario.password 			= this.confirmacion;
			this.user_vuex.email 			= this.usuario.email;
			this.user_vuex.password 		= this.confirmacion;
			this.usuario.fecha_nacimiento 	= "";

			if (this.datos.fecha_nacimiento != null) {
				this.usuario.fecha_nacimiento = this.datos.fecha_nacimiento.replace(
				/^(\d{4})-(\d{2})-(\d{2})$/g,
				"$3/$2/$1"
				);
			}
		},
        async verificarPass(tipo) {
            if (tipo === "confirmacion") {
                let isValid = await this.$refs.form2.validate();
                if (isValid) {
                    if (this.confirmacion == this.nuevo_password) {
                        this.password_igual = false;
                        this.updatePass();
                    } else {
                        this.password_igual = true;
                    }
                }
            } else if (tipo === "password_anterior") {
                if (this.usuario.password === this.user.password) {
                    this.accion = "cambio_password";
                    this.aprovo_password = false;
                    setTimeout(() => {
                        document.getElementById("nuevo_password").focus();
                    }, 100);
                } else {
                    this.aprovo_password = true;
                }
            }
        },
        async updatePass() {
            this.llena_datos();
            this.usuario.fecha_nacimiento = this.datos.fecha_nacimiento;
            this.loading02 = true
            await this.update_password(this.user_vuex);
            await userApi.updatePassword(this.usuario)
            .then(response => {
                this.cerrarModal();
                this.loading02 = false
                Notify.Success("Operación exitosa", "La contraseña ha sido actualizada correctamente.");
            })
            .catch(err => {
                this.loading02 = false
                Notify.Alert("Error", error.response.data.message, null, false);
            });
        },
        cerrarModal(){
            this.dialog_primer_login = false;
            this.modalCambiarPass = false;
            this.usuario.password = null
            this.nuevo_password = null;
            this.confirmacion = null;

            this.$nextTick(() => {
                if(this.$refs.form){
                    this.$refs.form.reset();
                }
                if(this.$refs.form2){
                    this.$refs.form2.reset();
                }
            });
        }
    },
    mounted() {
        this.usuario_nombre = this.datosLogin.nombre;

        if (this.datos.primer_inicio_sesion == true) {
            this.dialog_primer_login = true;
            setTimeout(function() {
                document.getElementById("nuevo_password").focus();
            }, 250);
        }


    },
    created() {
        this.datosLogin = this.$session.get("usuario");
        this.ImgUrl             = GetUrlImg.getURL();
        this.usuario.foto_url   = "/static/avatar/usuario4.jpg";

        if (this.ImgUrl != null && this.ImgUrl != "" && this.ImgUrl != undefined &&
            this.foto_usr != "" &&this.foto_usr != null &&this.foto_usr != undefined) {
            this.usuario.foto_url = this.ImgUrl + this.foto_usr;
        }
    },
}
</script>
<style>
    #no-background-hover::before {
        background-color: transparent !important;
    }
    .btnMenuTextNombre {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        color: #1E2245;
        text-transform: none;
        min-width: 200px;
        max-width: 250px;
        margin-right: 50px!important;
    }
    .user-name {
        padding-left: 10px;
        color: #96999A;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        cursor: pointer; 
        min-width: 100px;
        max-width: 150px;
        overflow: hidden;
        

        /* margin-top: 11px; */
    }
    .user-image {
        width: 35px;
        height: 35px;
        border-radius: 50%;
    }
    .user-container {
        width: 250px;
        padding: 5px 0px;
        background-color: #FFF;
    }
    div.user-menu-item {
        width: 100%;
        cursor: pointer;
        outline: 0;

        padding: 5px 16px;
    }
    div.user-menu-item span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 18px;
        letter-spacing: 0.1px;
        text-align: left;

        color: #96999A;
    }
    div.user-menu-item:hover {
        background-color: #f5faff;
    }
    div.user-menu-item:hover span {
        color: #1E2245;
    }
    .padding-x50{
		padding-left: 50px !important;
		padding-right: 50px !important;
	}
    .v-menu__content{
        border-radius: 15px;
        margin-top: 0px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    }
</style>